import { type QuestionnaireItem, type QuestionnaireResponseItem } from "fhir/r3"
import { BooleanQuestion } from "./BooleanQuestion"
import { ChoiceQuestion } from "./ChoiceQuestion"
import { DateTimeQuestion } from "./DateTimeQuestion"
import { DisplayQuestion } from "./DisplayQuestion"
import { GroupQuestion } from "./GroupQuestion"
import "./Question.scss"
import { StringQuestion } from "./StringQuestion"
import { TextQuestion } from "./TextQuestion"
import { MultipleChoiceQuestion } from "./MultipleChoiceQuestion"
import { useEffect } from "react"
import { capitalise } from "../../utils/stringFormatters"

export interface QuestionProps {
  topLevel: boolean
  question: QuestionnaireItem
  saveResponses: (answer: QuestionnaireResponseItem) => void
}

export function Question({ topLevel, question, saveResponses }: QuestionProps) {
  useEffect(() => {
    if (question.text) {
      document.title = capitalise(question.text)
    }
  }, [question.text])

  switch (question.type) {
    case "display":
      return <DisplayQuestion question={question} topLevel={topLevel} />
    case "string":
      return <StringQuestion question={question} saveResponses={saveResponses} topLevel={topLevel} />
    case "text":
      return <TextQuestion question={question} saveResponses={saveResponses} topLevel={topLevel} />
    case "boolean":
      return <BooleanQuestion question={question} saveResponses={saveResponses} topLevel={topLevel} />
    case "choice":
    case "open-choice":
      if (question.repeats) {
        return <MultipleChoiceQuestion question={question} saveResponses={saveResponses} topLevel={topLevel} />
      }
      return <ChoiceQuestion question={question} saveResponses={saveResponses} topLevel={topLevel} />
    case "group":
      return <GroupQuestion question={question} saveResponses={saveResponses} topLevel={topLevel} />

    case "date":
    case "dateTime":
    case "time":
      return <DateTimeQuestion question={question} saveResponses={saveResponses} topLevel={topLevel} />
    default:
      return null
  }
}
